module.exports = __webpack_public_path__ + "4ed42218f7904d4e9002d3901413cd29.pdf";